import { call, put, take, takeEvery, takeLatest, select } from 'redux-saga/effects'
import {
    FETCH_EVENTS, FETCH_GAME_BETS_ERROR, FETCH_EVENTS_ERROR, getActiveEvents, getEventBets, EVENTS_SET_ACTIVE, EVENTS_POST_BET, oracleCollectEmail, ORACLE_COLLECT_EMAILS_FAIL, ORACLE_COLLECT_EMAILS
} from '../constants/action-types';
import firebase from 'firebase';

/**
 * Get all the current events
 * @param {*} param0 
 */
function* oracleCollectEmails({ payload }) {

    try {

        const data = yield call((() => firebase.functions().httpsCallable(oracleCollectEmail)()))

    }
    catch (e) {

        yield put({ type: ORACLE_COLLECT_EMAILS_FAIL, payload: e.message })

    }

}

export default [
    takeLatest(ORACLE_COLLECT_EMAILS, oracleCollectEmails)
]


// WEBPACK FOOTER //
// ./src/sagas/oracle.js